module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C579"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Dedication")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C583"
  }, [_vm._v("For my family—I love you guys—always and forever.")]), _vm._v(" "), _c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/4_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdfb85f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedicati.vue
// module id = 63
// module chunks = 0